import React from "react";
import { CircularProgress, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import logo from "../assets/logo-nanthiat.png"; 

export default function Loader() {
  const theme = useTheme(); // Récupérer le thème MUI

  return (
    <Box 
      sx={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        height: "100vh", 
        position: "relative", 
        backgroundColor: theme.palette.background.default // Fond blanc ou foncé selon le mode
      }}
    >
      {/* Logo centré */}
      <Box 
        component="img" 
        src={logo} 
        alt="Logo Nanthiat" 
        sx={{ 
          width: 150, 
          height: 150, 
          position: "absolute", 
          zIndex: 2 // Le logo passe au-dessus du loader
        }} 
      />

      {/* Loader circulaire avec BLEU FONCÉ */}
      <CircularProgress 
        size={180} 
        thickness={1} 
        sx={{ 
          color: "#1E3A8A", // ✅ Bleu foncé (ex: Tailwind `blue-900`)
          position: "absolute",
          animationDuration: "1.5s",
        }} 
      />
    </Box>
  );
}
